import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-awareness',
  templateUrl: './awareness.component.html',
  styleUrls: ['./awareness.component.css']
})
export class AwarenessComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
